import React, { FC } from 'react';
import { MenuBlock, MenuItem } from 'moduleBase/types/Menu';
import { Nav } from 'react-bootstrap';
import SvgSprite from 'components/html-elements/SvgSprite';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import app from 'srcJs/App';
import { SelectCallback } from 'react-bootstrap/helpers';
import { When } from 'react-if';

type PropsType = {
  blocks: MenuBlock[],
  onSelect: SelectCallback,
  tools?: MenuItem[],
  faq?: MenuItem[],
}

const Tabs: FC<PropsType> = ({
  blocks,
  onSelect,
  tools,
  faq,
}) => {
  const items = blocks.map((block) => (
    <Nav.Item as="li" key={block.id}>
      <PopoverStickOnHover placement="right" text={block.label}>
        <Nav.Link eventKey={block.id} className="menu-panel-platform menu-panel-platform--vertical" onSelect={onSelect}>
          <span className="sr-only">
            {block.label}
          </span>
          <SvgSprite id={block.id} />
        </Nav.Link>
      </PopoverStickOnHover>
    </Nav.Item>
  ));

  return (
    <Nav as="ul" className="flex-column">
      {items}
      <When condition={!!tools}>
        <Nav.Item as="li">
          <PopoverStickOnHover placement="right" text={app.tForReact('base_menu', 'Tools')}>
            <Nav.Link
              eventKey="tools"
              className="menu-panel-platform menu-panel-platform--vertical"
              onSelect={onSelect}
            >
              <span className="sr-only">
                {app.tForReact('base_menu', 'Tools')}
              </span>
              <SvgSprite id="tools" />
            </Nav.Link>
          </PopoverStickOnHover>
        </Nav.Item>
      </When>
      <Nav.Item as="li">
        <PopoverStickOnHover placement="right" text={app.tForReact('base_menu', 'Technical support')}>
          <Nav.Link
            eventKey="support"
            className="menu-panel-platform menu-panel-platform--vertical"
            onSelect={onSelect}
          >
            <span className="sr-only">
              {app.tForReact('base_menu', 'Technical support')}
            </span>
            <SvgSprite id="support" />
          </Nav.Link>
        </PopoverStickOnHover>
      </Nav.Item>
      <When condition={!!faq}>
        <Nav.Item as="li">
          <PopoverStickOnHover placement="right" text={app.tForReact('base_menu', 'FAQ')}>
            <Nav.Link eventKey="faq" className="menu-panel-platform menu-panel-platform--vertical" onSelect={onSelect}>
              <span className="sr-only">
                {app.tForReact('base_menu', 'FAQ')}
              </span>
              <SvgSprite id="faq" />
            </Nav.Link>
          </PopoverStickOnHover>
        </Nav.Item>
      </When>
    </Nav>
  );
};

export { Tabs };
